export default __webpack_public_path__ + "static/media/Map.2a0a1fd1.png";